import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CloseCirc from 'shared-vectors/icons/CloseCirc';
import { Icon } from 'shared-vectors';
import createStyle from 'shared-utils/src/createStyle';
import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';
import styles, { mainCls } from './style';

const useStyles = createStyle(styles);

const TagButton = ({ action, label, index }) => {
  useStyles();

  return (
    <GridItem
      key={`fil_${index}`}
      behavior="fixed"
      className={`${mainCls}__item mr--s mb--s pl--s pr--s pb--xs pt--xs tp-s--s tp-w--m c-txt--f0 c-bg--bg b-r--m`}
      onClick={action}
    >
      <Grid
        className={`${mainCls}--ctn`}
        align="center"
        justify="space-between"
      >
        <p className={`${mainCls}--label`}>{label}</p>
        <Grid justify="center" className={`${mainCls}__item--del ml--ms`}>
          <Icon name={CloseCirc} color="f5" width="14px" height="14px" />
        </Grid>
      </Grid>
    </GridItem>
  );
};

TagButton.propTypes = {
  action: PropTypes.func,
  label: PropTypes.string,
  index: PropTypes.number,
};

TagButton.defaultProps = {
  action: () => {},
  label: '',
  index: 0,
};

export default TagButton;
